<script setup lang="ts">
import { useAnalyticsUserPropertiesSync } from '@/composables/analytics/useAnalyticsUserPropertiesSync';
import { useAnalyticsConsentSync } from '@/composables/analytics/useAnalyticsConsentSync';
import CookieConsentBanner from './core/cookie-consent/CookieConsentBanner.vue';
import DialogContainer from './core/dialogsystem/DialogContainer.vue';

useAnalyticsConsentSync();
useAnalyticsUserPropertiesSync();
</script>

<template>
  <RouterView />
  <DialogContainer />
  <CookieConsentBanner />
</template>
